import { dataLongVideoSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLongVideoSolid = /*#__PURE__*/createIcon(dataLongVideoSolid)
export default IconLongVideoSolid
